import { Outlet } from 'react-router-dom';

function Dex() {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default Dex;